module.exports = __webpack_public_path__ + "img/1588353339.59e40930.jpg";